import { render, staticRenderFns } from "./addMovieGenre.vue?vue&type=template&id=c342fbec&"
import script from "./addMovieGenre.vue?vue&type=script&lang=js&"
export * from "./addMovieGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports